module.exports = __webpack_public_path__ + "static/media/24.25da50c4.jpg";